export default __webpack_public_path__ + "d9f3ec817dc25430372de25da8b806c4.gif";